function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, { useState, useEffect } from "react";
import { Transition } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { ArrowRight } from "../../icons";
import { Button } from "../../atoms";
var MAX_FILE_SIZE = 1048576;
function sanitizeInput(input) {
    return input.replace(/<\/?[^>]+(>|$)|[<>]/g, "");
}
export default function VerificationModal(param) {
    var headlineText = param.headlineText, bodyText = param.bodyText, _error = param.error, error = _error === void 0 ? false : _error;
    var ref = _slicedToArray(useState(true), 2), show = ref[0], setShow = ref[1];
    var ref1 = _slicedToArray(useState(false), 2), animate = ref1[0], setAnimate = ref1[1];
    useEffect(function() {
        setAnimate(true);
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        "aria-live": "assertive",
        className: "z-50 pointer-events-none fixed inset-0 flex items-end px-4 py-6 md:p-6"
    }, " ", /*#__PURE__*/ React.createElement("div", {
        className: "flex w-full flex-col items-center space-y-4 "
    }, " ", /*#__PURE__*/ React.createElement(Transition, {
        show: show
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-1/6 md:h-auto flex md:block pointer-events-auto md:w-2/12 max-w-sm min-w-[190px] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ".concat(error ? "ring-red-medium " : "ring-black/5", " transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0 ").concat(animate ? "transform translate-y-0 opacity-100 duration-500 ease-out" : "transform translate-y-8 opacity-0 duration-500 ease-out")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "p-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-start"
    }, !error && /*#__PURE__*/ React.createElement("div", {
        className: "shrink-0"
    }, /*#__PURE__*/ React.createElement(CheckCircleIcon, {
        "aria-hidden": "true",
        className: "h-6 w-6 text-blue-medium"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "ml-3 w-0 flex-1 pt-0.5"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-sm font-medium text-gray-900"
    }, headlineText), /*#__PURE__*/ React.createElement("p", {
        className: "mt-1 text-sm text-gray-500"
    }, bodyText)), /*#__PURE__*/ React.createElement("div", {
        className: "ml-4 flex shrink-0"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: function() {
            setShow(false);
        },
        className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Close"), /*#__PURE__*/ React.createElement(XMarkIcon, {
        "aria-hidden": "true",
        className: "w-5 h-5"
    }))))))))));
}
export var JobApplicationForm = function(param) {
    var jobs = param.jobs, turnstileToken = param.turnstileToken, translationDict = param.translationDict;
    var ref = _slicedToArray(useState({
        jiraTicketId: "",
        jobTitle: "",
        firstName: "",
        lastName: "",
        email: "",
        cv: null,
        motivationLetter: null,
        expectedSalary: "",
        startDate: "",
        natoNationality: "",
        gdprConsent: false,
        aiConsent: false
    }), 2), formData = ref[0], setFormData = ref[1];
    var ref1 = _slicedToArray(useState(false), 2), showModal = ref1[0], setShowModal = ref1[1];
    var ref2 = _slicedToArray(useState(""), 2), modalHeadlineText = ref2[0], setModalHeadlineText = ref2[1];
    var ref3 = _slicedToArray(useState(""), 2), modalBodyText = ref3[0], setModalBodyText = ref3[1];
    var ref4 = _slicedToArray(useState("Submit Application!"), 2), buttonText = ref4[0], setButtonText = ref4[1];
    var ref5 = _slicedToArray(useState(false), 2), submitting = ref5[0], setSubmitting = ref5[1];
    var ref6 = _slicedToArray(useState(false), 2), hasFileError = ref6[0], setFileError = ref6[1];
    var ref7 = _slicedToArray(useState(false), 2), hasInputError = ref7[0], setInputError = ref7[1];
    var ref8 = _slicedToArray(useState(false), 2), hasNumberError = ref8[0], setNumberError = ref8[1];
    var handleChange = function(e) {
        // Validate file
        var _target = e.target, name = _target.name, value = _target.value, type = _target.type, checked = _target.checked, files = _target.files;
        if (type === "file") {
            var file = files[0];
            if (file && file.size > MAX_FILE_SIZE) {
                setFileError(true);
                return;
            }
            if (file.name.split(".").pop().toLowerCase() !== "pdf") {
                setFileError(true);
                return;
            }
        }
        // if no file-error, remove error message for next upload
        setFileError(false);
        if (name === "expectedSalary") {
            // Regular expression that matches an empty string or a string of digits only
            var integerRegex = /^(\d*)$/;
            if (!integerRegex.test(value)) {
                setNumberError(true);
                return;
            }
        }
        setNumberError(false);
        if (name === "job") {
            // Look up the selected job in the list
            var selectedJob = jobs.find(function(job) {
                return job.jiraTicketID === value;
            });
            var selectedJobTitle = selectedJob ? selectedJob.jobTitle : "";
            setFormData(_objectSpreadProps(_objectSpread({}, formData), {
                jiraTicketId: value,
                jobTitle: selectedJobTitle
            }));
        } else {
            setFormData(_objectSpreadProps(_objectSpread({}, formData), _defineProperty({}, name, type === "file" ? files[0] : type === "checkbox" ? checked : sanitizeInput(value))));
        }
    };
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(function(e) {
            var data, response, errorData, error;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setSubmitting(true);
                        if (submitting) {
                            setButtonText("Processing...");
                        }
                        data = new FormData();
                        Object.entries(formData).forEach(function(param) {
                            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                            if (key === "expectedSalary" && (!value || value === "0")) {
                                data.append(key, "0");
                            } else if (value !== null) {
                                var valueToAppend = typeof value === "boolean" ? value.toString() : value;
                                data.append(key, valueToAppend);
                            }
                        });
                        data.append("turnstileToken", turnstileToken);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            fetch("/jobApplicationFormSubmission", {
                                method: "POST",
                                body: data
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!!response.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        errorData = _state.sent();
                        setSubmitting(false);
                        setModalHeadlineText("An error occurred!");
                        setModalBodyText(errorData.error);
                        setInputError(true);
                        setShowModal(true);
                        _state.label = 4;
                    case 4:
                        if (response.status === 200) {
                            setButtonText("Success!");
                            setInputError(false);
                            setModalHeadlineText("Thanks for your application!");
                            setModalBodyText("You will receive a confirmation E-Mail with further information.");
                            setShowModal(true);
                            setSubmitting(true);
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("Error in JobApplicationForm:", error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-4"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "job",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.job.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("select", {
        id: "job",
        name: "job",
        value: formData.jiraTicketId,
        onChange: handleChange,
        required: true,
        className: "block w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
    }, /*#__PURE__*/ React.createElement("option", {
        value: ""
    }, translationDict.job.placeholder), jobs.map(function(job) {
        return /*#__PURE__*/ React.createElement("option", {
            key: job.jiraTicketID,
            value: job.jiraTicketID
        }, job.jobTitle);
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "firstName",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.firstName.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "firstName",
        name: "firstName",
        value: formData.firstName,
        onChange: handleChange,
        type: "text",
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none placeholder:opacity-100 placeholder:text-fg-inbetween",
        placeholder: translationDict.firstName.placeholder,
        required: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "lastName",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.lastName.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "lastName",
        name: "lastName",
        type: "text",
        value: formData.lastName,
        onChange: handleChange,
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none placeholder:opacity-100 placeholder:text-fg-inbetween",
        placeholder: translationDict.lastName.placeholder,
        required: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-4"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "email",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.email.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "email",
        name: "email",
        value: formData.email,
        onChange: handleChange,
        type: "email",
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none placeholder:opacity-100 placeholder:text-fg-inbetween",
        placeholder: translationDict.email.placeholder,
        required: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "col-span-full"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "cv",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.cv.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "cv",
        name: "cv",
        type: "file",
        accept: ".pdf",
        onChange: handleChange,
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none",
        required: true
    })), hasFileError && "File must be pdf and less than 1MB."), /*#__PURE__*/ React.createElement("div", {
        className: "col-span-full"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "motivationLetter",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.motivationLetter.label), /*#__PURE__*/ React.createElement("label", {
        style: {
            fontSize: "10px",
            marginLeft: "8px"
        }
    }, "(Optional)"), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "motivationLetter",
        name: "motivationLetter",
        type: "file",
        accept: ".pdf",
        onChange: handleChange,
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none"
    })), hasFileError && "File must be pdf and less than 1MB."), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "expectedSalary",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.expectedSalary.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "expectedSalary",
        name: "expectedSalary",
        value: formData.expectedSalary,
        onChange: handleChange,
        type: "number",
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none placeholder:opacity-100 placeholder:text-fg-inbetween"
    })), hasNumberError && "Please only enter numbers, no characters."), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "startDate",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.startDate.label), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "startDate",
        name: "startDate",
        value: formData.startDate,
        onChange: handleChange,
        type: "date",
        className: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-mediumlight placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-gray-400 sm:text-sm/6",
        required: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: "natoNationality",
        className: "font-bold tracking-widest text-xs text-fg-default"
    }, translationDict.natoNationality.label), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "natoNationality",
        name: "natoNationality",
        type: "text",
        value: formData.natoNationality,
        onChange: handleChange,
        className: "block w-full py-3 text-body.base leading-relaxed border-b border-b-fg-default bg-bg-default focus:outline-none placeholder:opacity-100 placeholder:text-fg-inbetween",
        placeholder: translationDict.natoNationality.placeholder,
        required: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3 flex justify-end"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        name: "submit",
        variant: "primary",
        disabled: submitting,
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }, buttonText))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3 flex items-start mt-7"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "gdprConsent",
        name: "gdprConsent",
        type: "checkbox",
        checked: formData.gdprConsent,
        onChange: handleChange,
        required: true,
        className: "mt-1.5 h-4 w-4 rounded border-gray-300 focus:ring-indigo-500"
    }), /*#__PURE__*/ React.createElement("label", {
        htmlFor: "gdprConsent",
        className: "ml-5 tracking-widest text-xs text-fg-default",
        style: {
            display: "block"
        }
    }, translationDict.gdprConsent.label, /*#__PURE__*/ React.createElement("a", {
        href: "/privacy-policy",
        className: "text-blue-500 underline",
        style: {
            fontSize: "10px",
            display: "block"
        }
    }, " Privacy Policy"))), /*#__PURE__*/ React.createElement("div", {
        className: "sm:col-span-3 flex items-start mt-4"
    }, /*#__PURE__*/ React.createElement("input", {
        id: "aiConsent",
        name: "aiConsent",
        type: "checkbox",
        checked: formData.aiConsent,
        onChange: handleChange,
        required: true,
        className: "mt-1.5 h-4 w-4 rounded border-gray-300 focus:ring-indigo-500"
    }), /*#__PURE__*/ React.createElement("label", {
        htmlFor: "gdprConsent",
        className: "ml-5 tracking-widest text-xs text-fg-default",
        style: {
            display: "block"
        }
    }, translationDict.aiConsent.label, /*#__PURE__*/ React.createElement("details", {
        className: "p-4 border rounded bg-gray-50 hover:bg-gray-100 transition-colors mt-4"
    }, /*#__PURE__*/ React.createElement("summary", {
        className: "cursor-pointer font-semibold flex items-center"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-5 w-5 text-yellow-500 mr-2",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v4m0 4h.01M12 2a10 10 0 110 20 10 10 0 010-20z"
    })), "Disclaimer on the Use of AI Tools in the Application Process"), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 text-sm text-gray-600"
    }, /*#__PURE__*/ React.createElement("p", null, "Please be aware that the creation and submission of application documents (e.g. CV, cover letter, case studies, etc.) using AI-powered tools is only permitted to a ", /*#__PURE__*/ React.createElement("strong", null, " limited extent "), "."), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("p", null, "Our expectations:"), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("ul", {
        className: "list-disc pl-5"
    }, /*#__PURE__*/ React.createElement("li", null, "Application documents must authentically reflect your own qualifications, personality, and motivation."), /*#__PURE__*/ React.createElement("li", null, "The use of AI for supportive purposes (e.g. spell-checking, improving wording) is acceptable."), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("strong", null, " Fully generated application documents created by AI without personal adaptation or review are not permitted.")), /*#__PURE__*/ React.createElement("li", null, "Under no circumstances may ", /*#__PURE__*/ React.createElement("strong", null, " NVISO information, data, or documents "), " be uploaded to or processed by external AI tools.")), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("p", null, "We reserve the right to exclude applications from the selection and interview process that are clearly created primarily or exclusively by AI and show no recognizable personal input."), /*#__PURE__*/ React.createElement("p", null, "The purpose of this policy is to ensure a fair and transparent recruitment process and to obtain an authentic impression of our applicants."))))))), showModal && /*#__PURE__*/ React.createElement(VerificationModal, {
        headlineText: modalHeadlineText,
        bodyText: modalBodyText,
        error: hasInputError
    }));
};

//# sourceMappingURL=JobApplicationForm.js.map